import BaseApi from "../BaseApi";

const baseApi = new BaseApi();

export default class Patient {
  Entity = "patient";

  create = async (data = null) => {
    if (!data) {
      throw new Error("Data is null...!!!");
    }

    const action = "add";
    const processedData = {
      patient: {
        id: 0,
        patient_code: data.patient_code,
        first_name: data.first_name,
        last_name: data.last_name,
        his_first_name: data.his_first_name,
        his_last_name: data.his_last_name,
        sex: data.sex,
      },
      study: {
        id: 0,
        inpatient_status: data.inpatient_status,
        request_number: data.request_number,
        modalities: data.modalities
      },
    };
    
    return baseApi.fullFetch(this.Entity, action, {data: processedData, showMessageSuccess: true});
  }
}
